import { Trans, useTranslation } from 'react-i18next';

import { AlertDialog, Button } from '~/components';
import { useIntl } from '~/hooks/useIntl';

type Props = {
  nextInvoiceAt: Date;
  onClose: (result: { unpause: boolean } | null) => void;
};

export const UnpauseInvoiceTemplateDialog = ({ nextInvoiceAt, onClose }: Props) => {
  const { formatDateShort } = useIntl();
  const { t } = useTranslation(['common', 'invoiceTemplates']);

  return (
    <AlertDialog.Body status="warning">
      <AlertDialog.Title>{t('invoiceTemplates:createEdit.unpauseModal.title')}</AlertDialog.Title>

      <AlertDialog.Description>
        <Trans
          components={{ break: <br /> }}
          i18nKey="invoiceTemplates:createEdit.unpauseModal.description"
          values={{ nextInvoiceAt: formatDateShort(nextInvoiceAt) }}
        />
      </AlertDialog.Description>

      <AlertDialog.Actions>
        <Button emphasis="secondary" onClick={() => onClose({ unpause: false })}>
          {t('invoiceTemplates:createEdit.unpauseModal.keepPaused')}
        </Button>
        <Button onClick={() => onClose({ unpause: true })}>{t('invoiceTemplates:createEdit.unpauseModal.unpause')}</Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
